import { getLoggerDbCore } from './LoggerDbCoreModule';

export async function storeLogsInIndexedDb(routeKey: string, logs: unknown[]): Promise<void> {
  const core = getLoggerDbCore();
  await core.storeLogs(logs, routeKey);
}

export async function configureLoggerIndexedDb(maxAgeMs: number, maxLogs: number, maxFailedLogs: number): Promise<void> {
  const core = getLoggerDbCore();
  core.configure({ maxAgeMs, maxLogs, maxFailedLogs });
}

export async function flushLogsInIndexedDb(routeKey: string, endpoint: string): Promise<void> {
  const core = getLoggerDbCore();
  await core.flushLogs(routeKey, endpoint);
}

export async function flushLogsInIndexedDbRequest(routeKey: string, endpoint: string): Promise<void> {
  const core = getLoggerDbCore();
  const result = await core.flushLogsCore(routeKey, endpoint);

  if (!result || !result.ok) {
    throw new Error(result?.errorMessage || `IndexedDB flush failed for ${routeKey}`);
  }
}
